import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useSearchParams } from 'next/navigation';

import TicketFormItem from '@/components/event-payment/ticket-form-item';
import { FormSlide } from '@/components/event-payment/types';
import { selectTicket } from '@/store/event-payment/event-payment.actions';
import { WithLang } from '@/types/general/base';
import { TicketSelectOption } from '@/types/tickets';

interface Props {
    ticketOptions: TicketSelectOption[];
    onSlide: () => void;
}

export default function TicketForm(props: WithLang<Props>) {
    const sortedTickets = props.ticketOptions?.sort((a, b) => a.price - b.price);
    const searchParams = useSearchParams();
    const formSlide = Number(searchParams.get('form-slide')) as FormSlide;
    const dispatch = useDispatch();

    useEffect(() => {
        if (formSlide === FormSlide.submit && sortedTickets) {
            dispatch(
                selectTicket({
                    ticket: sortedTickets[0],
                    action: 'increase',
                }),
            );
        }
    }, [dispatch, formSlide, sortedTickets]);

    return (
        <div className="flex min-w-full justify-center">
            <div className="flex w-[40rem] flex-col gap-3">
                {sortedTickets.map((item, index) => (
                    <TicketFormItem lang={props.lang} key={index} ticketOption={item} />
                ))}
            </div>
        </div>
    );
}
